import React from "react";
import "./notifications.scss";

export interface INotificationCountProps {
  count?: number;
  left: number;
  top: number;
}

function NotificationCount(props: INotificationCountProps) {
  return (
    <>
      {typeof props.count === "number" && props.count > 0 && (
        <span
          className="notification-badge-positioning"
          style={{
            left: props.left,
            top: props.top,
          }}
        >
          <span className="notification-count-badge">
            {props.count >= 100 ? "99+" : props.count}
          </span>
        </span>
      )}
    </>
  );
}

export default NotificationCount;
